import { FinCalcSpcContext } from './FinCalcSpcContext';
import { useContext, useCallback } from 'react';

export interface IUseToggleFinCalcSpc {
  toggleFinanceCalculatorSpc: (shouldOpen: boolean) => void;
  isFinCalcSpcModalOpen: boolean;
}

export default function useToggleFinCalcSpc(): IUseToggleFinCalcSpc {
  const { isFinCalcSpcOpen, setIsFinCalcSpcOpen } = useContext(FinCalcSpcContext);

  const toggleFinanceCalculatorSpc: (shouldOpen: boolean) => void = useCallback(
    shouldOpen => setIsFinCalcSpcOpen(shouldOpen),
    [setIsFinCalcSpcOpen],
  );

  return { isFinCalcSpcModalOpen: isFinCalcSpcOpen, toggleFinanceCalculatorSpc };
}
